let host = 'frog.wix.com';

export function setHost(_host) {
  host = _host;
}

export function getHost() {
  return host;
}

export function isWebWorker() {
  /* global WorkerGlobalScope */

  //At the moment, this is the most reliable way of detecting if current code is run in a worker
  //Taken from here: https://stackoverflow.com/a/18002694
  return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}

/**
 * Provides a window object to the callback iff current window is the topmost one
 * Otherwise returns null
 */
export function provideBrowsingContext(cb) {
  if (typeof window !== 'undefined' && window) {
    try {
      return window.top === window.self ? (cb ? cb(window) : window) : null;
    } catch (e) {
      return null;
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./lib/env.js